import Vue from 'vue'
import dayjs from '~/utils/dayjs'

export default ({ app }) => {
  Vue.filter('currency', function (value, options) {
    const defaultOptions = {
      currency: 'EUR',
      prefix: '',
      minimumFractionDigits: 2
    }

    const _options = {
      ...defaultOptions,
      ...options,
      ...{
        currency: options.currency || defaultOptions.currency
      }
    }

    return Intl.NumberFormat(app.i18n.localeProperties.iso, {
      style: 'currency',
      currencyDisplay: 'code',
      ..._options
    })
      .format(!value || isNaN(value) ? 0 : value)
      .replace(/^(\D+)/, `${String(_options.prefix)} $1`)
      .trim()
  })

  Vue.filter('prettify', (value) => {
    const minutes = Math.floor(value / 60)
      .toString()
      .padStart(2, '0')
    const seconds = (value - minutes * 60).toString().padStart(2, '0')

    return minutes + ':' + seconds
  })

  Vue.filter('dateLocalize', (value) => {
    const date = new Date(value.replace(/-/g, '/'))

    return dayjs(date).locale(app.i18n.locale).format('DD.MM.YY HH:mm')
  })

  Vue.filter('dateToStr', (date) => {
    if (!date) {
      return date
    }
    const t = date.split(/[- :]/)
    return new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0)
  })

  Vue.filter('dateStr', (date) => {
    return dayjs(date)
      .locale(app.i18n.locale)
      .format('D MMMM YYYY, HH:mm (dddd)')
  })

  Vue.filter('dateStrNumeric', (date) => {
    return dayjs(date).locale(app.i18n.locale).format('DD.MM.YYYY, HH:mm')
  })

  Vue.filter('dateStrLong', (date) => {
    return dayjs(date)
      .locale(app.i18n.locale)
      .format('DD.MM.YYYY, HH:mm (dddd)')
  })
}
